import { ECheckInQuestionnairePayload } from 'models';
import { tokenAuthApiInstance } from 'utils/auth';

import { getSaveFormIOQuestionnaireEndpoint, SPECIFIC_INFORMATIOM_ENDPOINT } from '../constants';

/* eslint-disable @typescript-eslint/no-explicit-any */
export const saveFormIOQuestionnaire = async (
  practiceCalendarID: string,
  isFormIO: boolean,
  savePayload: Array<ECheckInQuestionnairePayload>
): Promise<any> => {
  const response = await tokenAuthApiInstance
    .authAxios()
    .post(getSaveFormIOQuestionnaireEndpoint(practiceCalendarID, isFormIO), savePayload);
  return response.data;
};
//Save the SpecificInformation in questionnaire end point
export const saveSpecificInformation = async (
  SpecificInformation: string,
  practiceCalendarID: string,
  FormStatus: string
): Promise<any> => {
  const response = await tokenAuthApiInstance.authAxios().post(SPECIFIC_INFORMATIOM_ENDPOINT(practiceCalendarID), {
    SpecificInformation,
    SpecificInformationStatus: FormStatus,
  });
  return response.data;
};
